import $ from "jquery";
import axios from "axios";
import {MODAL_INFO_SIGN_UP} from "Core/links";

export const renderSignUpSuccessModal = () => {
    const mainModal = $('#signup-social');

    if (mainModal.find('.modal-close').length > 0) {
        mainModal.find('.modal-close:first').click();
    }

    axios.get(MODAL_INFO_SIGN_UP)
        .then((response) => {
            $('#modal-info-block').html(response.data);

            $('#signUpModalInfo').click(function () {
                $('#successful-login').remove();
            });
        });
};
